import React from 'react';
import longlengthImage from "../../assests/kpp.jpg";

function Banner() {
  return (
    <div className="banner-image">
      <img style={{ width: "100%", height: "15rem" }} src={longlengthImage} alt="" />
    </div>
  );
}

export default Banner;
